import { render } from "./vali-input.vue?vue&type=template&id=ae018474"
import script from "./vali-input.vue?vue&type=script&lang=js"
export * from "./vali-input.vue?vue&type=script&lang=js"

import "./vali-input.vue?vue&type=style&index=0&id=ae018474&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__